import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import Api from 'util/Api';
import API from 'constants/api';
import { authProfile } from 'redux/auth/selectors';

export interface WarehouseLocation {
  id: number;
  address: string;
  lat: number;
  lng: number;
  zoneId: number;
  county: string;
  postalCode: string;
  countryID: number;
  cityID: number;
}

export interface Warehouse {
  id: number;
  name: string;
  address: string;
  locationAddress: WarehouseLocation;
  ownerLogisticOperatorId: number;
  customerId: number;
  contactName: string;
  phone: string;
  detail: string;
  volume: number;
  active: boolean;
  private: boolean;
  published: boolean;
  openBranchOffice: boolean;
}

const getWarehouse = async (warehouseId: number): Promise<Warehouse> => {
  const { data } = await Api.apiAxios.get(API.profile.paquerypointInfo(warehouseId));
  return data.data;
};

export const useWarehouse = () => {
  const profile = useSelector(authProfile);
  const warehouseId: number = profile?.paquerypoint?.id;

  return useQuery({
    queryKey: ['warehouse', warehouseId],
    queryFn: () => getWarehouse(warehouseId),
    enabled: !!warehouseId,
    staleTime: Infinity,
  });
};
